








































import { defineComponent, toRefs, watch, ref, computed } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { DestinationUrlType, customProductPageUrlReg } from '@tt4b/ttam-enums';

const name = 'custom-product-page-switch';

export default defineComponent({
  name,
  components: {
    QuestionTooltip,
  },
  props: {
    customProductPageUrl: {
      type: String,
      default: '',
    },
    isValidateSuccess: {
      type: Boolean,
      default: false,
    },
    isUseCustomProductPage: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { customProductPageUrl: customProductPageUrlFromProps } = toRefs(props);

    const customProductPageUrlLocal = ref(customProductPageUrlFromProps.value);

    const customProductPageUrlModel = computed({
      get: () => customProductPageUrlFromProps.value,
      set: val => {
        customProductPageUrlLocal.value = val;
      },
    });

    const updateCustomProductPageUrl = () => {
      emit('changeCustomProductPageUrl', customProductPageUrlLocal.value);
    };

    const isValid = computed(() => customProductPageUrlReg.test(customProductPageUrlModel.value));

    const changeUseCustomProductPage = (value: boolean) => {
      emit('changeUseCustomProductPage', value);
    };

    const previewCustomProductPageUrl = () => {
      window.open(customProductPageUrlModel.value, '_blank');
    };

    watch(
      () => props?.customProductPageUrl,
      () => {
        customProductPageUrlLocal.value = props.customProductPageUrl;
      },
    );

    return {
      name,
      DestinationUrlType,
      isValid,
      customProductPageUrlModel,
      previewCustomProductPageUrl,
      changeUseCustomProductPage,
      updateCustomProductPageUrl,
    };
  },
});
